import { Theme } from '../../types/enums';

enum PromotionalMessageType {
  APPLIED = 'APPLIED',
  POTENTIAL = 'POTENTIAL',
  EXPIRED = 'EXPIRED',
}

enum PromotionalMessageTypeTheme {
  APPLIED = Theme.SUCCESS,
  POTENTIAL = Theme.PURPLE,
  EXPIRED = Theme.GRAY,
}

enum PromotionalMessageTextSize {
  SMALL = 'small',
  LARGE = 'large',
}

export { PromotionalMessageTextSize, PromotionalMessageType, PromotionalMessageTypeTheme };
